import React from 'react';
import { cn } from '../../lib/utils';

interface AppShellProps {
  children: React.ReactNode;
  className?: string;
}

const AppShell: React.FC<AppShellProps> = ({ children, className }) => {
  return (
    <div className={cn("min-h-screen bg-background overflow-x-hidden", className)}>
      {children}
    </div>
  );
};

export default AppShell;
